function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5003 0.178711C6.29199 0.178711 1.84408 3.41829 0.0419922 7.99121C1.84408 12.5641 6.29199 15.8037 11.5003 15.8037C16.7087 15.8037 21.1566 12.5641 22.9587 7.99121C21.1566 3.41829 16.7087 0.178711 11.5003 0.178711ZM11.5003 13.1995C8.62533 13.1995 6.29199 10.8662 6.29199 7.99121C6.29199 5.11621 8.62533 2.78288 11.5003 2.78288C14.3753 2.78288 16.7087 5.11621 16.7087 7.99121C16.7087 10.8662 14.3753 13.1995 11.5003 13.1995ZM11.5003 4.86621C9.77116 4.86621 8.37533 6.26204 8.37533 7.99121C8.37533 9.72038 9.77116 11.1162 11.5003 11.1162C13.2295 11.1162 14.6253 9.72038 14.6253 7.99121C14.6253 6.26204 13.2295 4.86621 11.5003 4.86621Z",
  fill: "#00324E"
});

function SvgPasswordEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeOpen);
export default __webpack_public_path__ + "static/media/password-eye-open.556d0392.svg";
export { ForwardRef as ReactComponent };